function MenuIcon(props) {
  return (
    <svg
      id='MenuIcon'
      data-name='Page 1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 39.979 33.313'
      {...props}
    >
      <defs>
        <clipPath id='clip-path'>
          <path id='Clip_2' data-name='Clip 2' d='M39.979,33.313H0V0H39.979V33.313Z' fill='none' />
        </clipPath>
      </defs>
      <path id='Clip_2-2' data-name='Clip 2' d='M39.979,33.313H0V0H39.979V33.313Z' fill='none' />
      <g id='Page_1-2' data-name='Page 1' clipPath='url(#clip-path)'>
        <path
          id='Fill_1'
          data-name='Fill 1'
          d='M38.868,33.313H11.105A1.111,1.111,0,0,1,10,32.2V31.092a1.111,1.111,0,0,1,1.11-1.111H38.868a1.112,1.112,0,0,1,1.111,1.111V32.2A1.112,1.112,0,0,1,38.868,33.313Zm-34.426,0H1.111A1.112,1.112,0,0,1,0,32.2V31.092a1.112,1.112,0,0,1,1.111-1.111H4.442a1.112,1.112,0,0,1,1.111,1.111V32.2A1.112,1.112,0,0,1,4.442,33.313ZM38.868,17.767H11.105A1.111,1.111,0,0,1,10,16.656V15.546a1.111,1.111,0,0,1,1.11-1.11H38.868a1.111,1.111,0,0,1,1.111,1.11v1.111A1.112,1.112,0,0,1,38.868,17.767Zm-34.426,0H1.111A1.112,1.112,0,0,1,0,16.656V15.546a1.111,1.111,0,0,1,1.111-1.11H4.442a1.111,1.111,0,0,1,1.111,1.11v1.111A1.112,1.112,0,0,1,4.442,17.767ZM38.868,3.331H11.105A1.111,1.111,0,0,1,10,2.221V1.111A1.111,1.111,0,0,1,11.105,0H38.868a1.112,1.112,0,0,1,1.111,1.111V2.221A1.111,1.111,0,0,1,38.868,3.331Zm-34.426,0H1.111A1.111,1.111,0,0,1,0,2.221V1.111A1.112,1.112,0,0,1,1.111,0H4.442A1.112,1.112,0,0,1,5.553,1.111V2.221A1.111,1.111,0,0,1,4.442,3.331Z'
          transform='translate(0 0)'
        />
      </g>
    </svg>
  )
}

export default MenuIcon
